import React from "react";
import Styles from "./RaMain.module.css";
import CreateScreen from "../../../../../Components/ReverseAuction/CreateScreen/CreateScreen";
import { useSelector } from "react-redux";
const ReverseAuctionConsumer = ({ rfq }) => {
  return (
    <div className={Styles.raMainScreen}>
      <CreateScreen rfq={rfq} />
    </div>
  );
};

export default ReverseAuctionConsumer;
